import { API_ENDPOINT } from 'src/config/env.config';
import { baseApi } from './axios';
import {
	BaseAPIResponse,
	GetVideoResumeByIdAPIResponse,
	GetVideoResumesAPIResponse,
	VideoResumeCreateInput,
} from 'types';

const baseUrl = `${API_ENDPOINT}/video-resume`;

export const createVideoResume = async (payload: VideoResumeCreateInput): Promise<BaseAPIResponse> => {
	const response = await baseApi.post(`${baseUrl}/create`, { ...payload });
	return response.data;
};

export const getVideoResumeByIdQuery = async (id: string): Promise<GetVideoResumeByIdAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}/${id}`);
	return response.data;
};

export const getVideoResumes = async (): Promise<GetVideoResumesAPIResponse> => {
	const response = await baseApi.get(`${baseUrl}`);
	return response.data;
};
